import { Component, Input, OnInit } from '@angular/core'
import { ThemeSelectorService } from 'src/app/services/theme-selector.service'
import { PricingService } from '../../../../digitalvenue/services/pricing.service'

@Component({
  selector: 'app-parking-seat-element',
  templateUrl: './parking-seat-element.component.html',
  styleUrls: ['./parking-seat-element.component.scss']
})
export class ParkingSeatElementComponent implements OnInit {
  @Input() parkingHash;
  @Input() parking;
  @Input() parkingName;
  totalPrice: number;
  constructor(private themeSelector: ThemeSelectorService, private pricingService: PricingService) { }

  ngOnInit() {
    this.init();
  }

  private init(): void {
    this.totalPrice = 0;
    const priceToUse = this.pricingService.getPriceToUse()
    for ( const parking of this.parking ) {
      this.totalPrice += parking[priceToUse] || parking.price;
    }
  }

  getTheme() {
    return this.themeSelector.isDarkTheme;
  }

  formatPrice(price: number) {
    return price.toLocaleString('en-US', {minimumFractionDigits: 0, maximumFractionDigits: 2});
  }

}
